import axios from 'axios'
import {serialize} from '../../../core/_util'
export const API_URL = process.env.REACT_APP_BASE_API_URL
const GET_ALL_DATA_ROOMS = `${API_URL}/data-rooms/all`
const CREATE_DATA_ROOMS = `${API_URL}/data-rooms`
const GET_DATA_ROOM = `${API_URL}/data-rooms/details`
const UPDATE_DATA_ROOMS = `${API_URL}/data-rooms/update`
const DELETE_DATA_ROOMS = `${API_URL}/data-rooms/delete`
const Clone_DATA_ROOMS = `${API_URL}/data-rooms`
const EDIT_DATA_ROOM_STATUS = `${API_URL}/data-rooms/update`
const GET_DATA_ROOM_CONTENT = `${API_URL}/contents/data-room`
const GET_DATA_ROOM_CONTENT_BY_PARENT = `${API_URL}/contents`
const GET_ALL_CONTENT = `${API_URL}/contents`
const UPDATE_IS_HIDDEN = `${API_URL}/update/dataroom_content`
const RENAME_FOLDER_NAME = `${API_URL}/contents`
const GET_ALL_SHARE_LINKS = `${API_URL}/data-rooms`
const GET_ALL_SHARE_LINKS_FILE = `${API_URL}/contents`
const UPDATE_DATA_ROOM_STATUS = `${API_URL}/data-rooms/share-links/update`
const DELETE_SHARE_LINK = `${API_URL}/data-rooms/share-links/delete`
const MOVE_FILE_TO_FOLDER = `${API_URL}/contents/add-parentid`
const EXTRACT_ZIP = `${API_URL}/contents/zip-generation`
const CREATE_SHARE_LINK = `${API_URL}/data-rooms`
const CREATE_SHARE_LINK_FILE = `${API_URL}/contents`
const GET_SHARE_LINK = `${API_URL}/data-rooms/share-links`
const ADD_MORE_FILES = `${API_URL}/contents/public-url`
const ADD_FILE_TO_DATAROOMUPLOADS = `${API_URL}/content/data-room`
const CREATE_CONTENT_COPY_IN_DR = `${API_URL}/contents/data-room/update`
const DATAROOM_PUBLIC_VIEW = `${API_URL}/data-rooms/public`
const NAVIGATE_IN_FOLDER_DRPREVIEW = `${API_URL}/data-rooms/public/nested`
const GET_CONTENT_UUID = `${API_URL}/contents`
const CONTENT_PUBLIC_VIEW = `${API_URL}/contents/public`
const GET_STATISTICS_DATA_ROOM = `${API_URL}/data-rooms/statistics`
const SHOW_RECENT_VISITS = `${API_URL}/contents/recent-visits`
const CREATE_VISITS = `${API_URL}/visits`
const TIME_SPEND = `${API_URL}/timespend`
const GET_SINGLE_CONTENT = `${API_URL}/visits`
const GET_SINGLE_CONTENT_TIME_SPEND = `${API_URL}/timespend`
const GET_LOCATION = `${API_URL}/visits/location`
const GET_STATISTICS_DATA_ROOM_TIME_SPENT = `${API_URL}/data-rooms/statistics/time-spent`
const FILE_VIEW_IN_DATAROOM = `${API_URL}/data-rooms/public/content`
const DELETE_CONTENT_DRROOT = `${API_URL}/delete/dataroom_content`

const GET_SIGNEDURL_CONTENT = `${API_URL}/content/signed`
const GET_ACCOUNT = `${API_URL}/accounts`

export const getAllDataRooms = (companyId: number, searchValue: string, dataRoomstatus: string) => {
  const object = {
    name: searchValue,
    status: dataRoomstatus,
  }
  return axios.get(`${GET_ALL_DATA_ROOMS}/${companyId}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createDataRoom = (payload: any) => {
  return axios.post(`${CREATE_DATA_ROOMS}`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateDataRoom = (payload: any, dataRoomId: number) => {
  return axios.put(`${UPDATE_DATA_ROOMS}/${dataRoomId}`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const getDataRoom = (dataRoomId: number) => {
  return axios.get(`${GET_DATA_ROOM}/${dataRoomId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteDataRoom = (dataRoomId: number) => {
  return axios.delete(`${DELETE_DATA_ROOMS}/${dataRoomId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const cloneDataRoom = (dataRoomId: number) => {
  return axios.post(`${Clone_DATA_ROOMS}/${dataRoomId}/clone`, {
    validateStatus() {
      return true
    },
  })
}

export const getDataRoomContent = (dataRoomId: number, is_hidden: string, parentId: any) => {
  if (parentId) {
    const object = {
      type: is_hidden,
      parentId: parentId,
    }
    return axios.get(`${GET_DATA_ROOM_CONTENT}/${dataRoomId}?${serialize(object)}`, {
      validateStatus() {
        return true
      },
    })
  } else {
    const object = {
      type: is_hidden,
    }
    return axios.get(`${GET_DATA_ROOM_CONTENT}/${dataRoomId}?${serialize(object)}`, {
      validateStatus() {
        return true
      },
    })
  }
}

export const getDataRoomContentParent = (parentId: string) => {
  return axios.get(`${GET_DATA_ROOM_CONTENT_BY_PARENT}?parentId=${parentId}`, {
    validateStatus(status) {
      return true
    },
  })
}
export const getAllShareLinks = (dataRoomId: number) => {
  return axios.get(`${GET_ALL_SHARE_LINKS}/${dataRoomId}/share-links`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllShareLinksFiles = (contentId: string) => {
  return axios.get(`${GET_ALL_SHARE_LINKS_FILE}/${contentId}/share-links`, {
    validateStatus(status) {
      return true
    },
  })
}

export const editDataRoomsStatus = ({
  dataRoomId,
  title,
  subtitle,
  status,
  logoId,
  bannerId,
}: any) => {
  return axios.put(
    `${EDIT_DATA_ROOM_STATUS}/${dataRoomId}`,
    {
      title,
      subtitle,
      status,
      logoId,
      bannerId,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const updateShareLinkStatus = (shareLinkId: number, payloadObject: any) => {
  return axios.put(`${UPDATE_DATA_ROOM_STATUS}/${shareLinkId}`, payloadObject, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllContent = () => {
  return axios.get(GET_ALL_CONTENT, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteFolder = (contentId: string, companyId?: any) => {
  const queryParams = {
    companyId,
  }
  return axios.delete(`${GET_ALL_CONTENT}/${contentId}?${serialize(queryParams)}`, {
    validateStatus(status) {
      return true
    },
  })
}

// export const updateIsHiddenToggle = (contentId: number, dataRoomId: number, isHidden: boolean) => {
//   return axios.put(
//     `${UPDATE_IS_HIDDEN}/${contentId}/data-room/${dataRoomId}`,
//     {isHidden},
//     {
//       validateStatus() {
//         return true
//       },
//     }
//   )
// }

export const updateContent = (contentId: string, name: string, companyId?: any) => {
  const queryParams = {
    companyId,
  }
  return axios.put(
    `${GET_ALL_CONTENT}/${contentId}?${serialize(queryParams)}`,
    {name},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const renameFolderName = (contentId: string, name: string) => {
  return axios.put(
    `${RENAME_FOLDER_NAME}/${contentId}`,
    {name},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteShareLinkId = (shareLinkId: number) => {
  return axios.delete(`${DELETE_SHARE_LINK}/${shareLinkId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const moveFileToFolder = (
  contentId: string,
  parentId: string | undefined,
  companyId: number
) => {
  const data = {
    companyId,
    parentId,
    contentId,
  }

  return axios.put(MOVE_FILE_TO_FOLDER, data, {
    validateStatus(status) {
      return true
    },
  })
}
export const getAllFoldersList = (companyId: number) => {
  const queryParams = {
    companyId,
  }
  return axios.get(`${GET_ALL_CONTENT}?${serialize(queryParams)}`, {
    params: queryParams,
    validateStatus(status) {
      return true
    },
  })
}

export const addContent = (type: string, companyId: number, name: string, parentId: string) => {
  const payload = {
    type,
    companyId,
    name,
    parentId,
  }

  return axios.post(GET_ALL_CONTENT, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const addMoreFilesPublicUrl = (
  name: string,
  URL: string,
  parentId: string,
  companyId: number
) => {
  let payload
  if (!parentId) {
    payload = {
      name,
      URL,
      companyId,
    }
  } else {
    payload = {
      name,
      URL,
      parentId,
      companyId,
    }
  }

  return axios.post(ADD_MORE_FILES, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const createShareLink = (dataRoomId: Number, payload: any) => {
  return axios.post(`${CREATE_SHARE_LINK}/${dataRoomId}/share-links`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const createShareLinkFile = (contentId: string, payload: any) => {
  return axios.post(`${CREATE_SHARE_LINK_FILE}/${contentId}/share-links`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const extractZip = (contentId: string) => {
  return axios.get(`${EXTRACT_ZIP}/${contentId}`, {
    validateStatus(status) {
      return true
    },
  })
}
export const getShareLink = (linkId: Number) => {
  return axios.get(`${GET_SHARE_LINK}/${linkId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getBreadcrumbList = (parentId: string) => {
  const queryParams = {
    parentId,
  }
  return axios.get(`${GET_ALL_CONTENT}?${serialize(queryParams)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getCompanyChildrenList = (parentId: string, companyId?: number) => {
  const queryParams = {
    parentId,
    companyId,
  }
  return axios.get(`${GET_ALL_CONTENT}?${serialize(queryParams)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const addMoreFiles = (
  type: string,
  companyId: number,
  name: string,
  fileId: number,
  parentId: string
) => {
  const payload = {
    type,
    companyId,
    name,
    fileId,
    parentId,
  }

  return axios.post(GET_ALL_CONTENT, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const uploadFileToDataRoomUploads = (
  name: string,
  type: string,
  fileId: number,
  dataRoomId: number
) => {
  const payload = {
    name,
    type,
    fileId,
  }

  return axios.post(`${ADD_FILE_TO_DATAROOMUPLOADS}/${dataRoomId}`, payload, {
    validateStatus() {
      return true
    },
  })
}

export const createContentCopyDataRoom = (
  contentIdList: any,
  isHidden: boolean,
  dataRoomId: number,
  parentId: any
) => {
  const payload = {
    contentIdList,
    isHidden,
    parentId,
  }

  return axios.post(`${CREATE_CONTENT_COPY_IN_DR}/${dataRoomId}`, payload, {
    validateStatus() {
      return true
    },
  })
}
export const getFileByShareLink = (
  uuid: string,
  passcode: string | undefined,
  email: string | undefined,
  otp: string | undefined
) => {
  if (otp) {
    const headers: any = {
      'x-otp': otp,
      'x-email': email,
    }
    return axios.get(`${DATAROOM_PUBLIC_VIEW}/${uuid}`, {
      headers: headers,
      validateStatus(status) {
        return true
      },
    })
  } else if ((email === undefined || email === '') && (passcode === undefined || passcode === '')) {
    return axios.get(`${DATAROOM_PUBLIC_VIEW}/${uuid}`, {
      validateStatus(status) {
        return true
      },
    })
  } else if ((email !== undefined || email !== '') && (passcode === undefined || passcode === '')) {
    const headers: any = {
      'x-email': email,
    }
    return axios.get(`${DATAROOM_PUBLIC_VIEW}/${uuid}`, {
      headers: headers,

      validateStatus(status) {
        return true
      },
    })
  } else if ((email === undefined || email === '') && (passcode !== undefined || passcode !== '')) {
    const headers: any = {
      'x-passcode': passcode,
    }
    return axios.get(`${DATAROOM_PUBLIC_VIEW}/${uuid}`, {
      headers: headers,

      validateStatus(status) {
        return true
      },
    })
  } else {
    const headers: any = {
      'x-passcode': passcode,
      'x-email': email,
    }
    return axios.get(`${DATAROOM_PUBLIC_VIEW}/${uuid}`, {
      headers: headers,

      validateStatus(status) {
        return true
      },
    })
  }
}

export const openFolderDrShareLink = (parentId: string | null, sessionToken: string | null) => {
  const headers = {
    'x-session-token': sessionToken!,
  }
  const object = {
    parentId: parentId,
  }

  return axios.get(`${NAVIGATE_IN_FOLDER_DRPREVIEW}?${serialize(object)}`, {
    headers: headers,
  })
}

export const getContentPublicShareLink = (
  uuid: string,
  passcode: string,
  email: string,
  otp: string | undefined
) => {
  if (otp) {
    const headers: any = {
      'X-Otp': otp,
    }
    return axios.get(`${CONTENT_PUBLIC_VIEW}/${uuid}`, {
      headers: headers,
      validateStatus(status) {
        return true
      },
    })
  } else if ((email === undefined || email === '') && (passcode === undefined || passcode === '')) {
    return axios.get(`${CONTENT_PUBLIC_VIEW}/${uuid}`, {
      validateStatus(status) {
        return true
      },
    })
  } else if ((email !== undefined || email !== '') && (passcode === undefined || passcode === '')) {
    const headers = {
      'X-Email': email,
    }
    return axios.get(`${CONTENT_PUBLIC_VIEW}/${uuid}`, {
      headers: headers,
      validateStatus(status) {
        return true
      },
    })
  } else if ((email === undefined || email === '') && (passcode !== undefined || passcode !== '')) {
    const headers = {
      'X-Passcode': passcode,
    }
    return axios.get(`${CONTENT_PUBLIC_VIEW}/${uuid}`, {
      headers: headers,
      validateStatus(status) {
        return true
      },
    })
  } else {
    const headers = {
      'X-Passcode': passcode,
      'X-Email': email,
    }

    return axios.get(`${CONTENT_PUBLIC_VIEW}/${uuid}`, {
      headers: headers,
      validateStatus(status) {
        return true
      },
    })
  }
}

export const getStatisticsDataRoom = (companyId: number, progress: string) => {
  return axios.get(`${GET_STATISTICS_DATA_ROOM}/${companyId}?week=${progress}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getStatisticsDataRoomTimeSpent = (companyId: number, progress: string) => {
  return axios.get(`${GET_STATISTICS_DATA_ROOM_TIME_SPENT}/${companyId}?week=${progress}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const showRecentVisits = (companyId: number) => {
  return axios.get(`${SHOW_RECENT_VISITS}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getFileUuid = (contentId: string) => {
  return axios.get(`${GET_CONTENT_UUID}/${contentId}/share-links`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createVisits = (
  deviceType: string,
  osType: string,
  city: string,
  country: string,
  ipAddress: string,
  contentId: string,
  email: string | undefined,
  publicSessionTokenDataroomFile: string
) => {
  const payload = {
    deviceType: deviceType,
    os: osType,
    city: city,
    ipAddress: ipAddress,
    country: country,
    contentId: contentId,
    visitorEmail: email,
  }
  const headers = {
    'x-session-token': publicSessionTokenDataroomFile,
  }

  return axios.post(`${CREATE_VISITS}`, payload, {
    headers: headers,
    validateStatus() {
      return true
    },
  })
}

export const createTimeSpent = (timeSpent: number, visitId: number) => {
  const payload = {
    totalTimeSpend: timeSpent,
    visitId: visitId,
  }
  return axios.post(`${TIME_SPEND}`, payload, {
    validateStatus() {
      return true
    },
  })
}

export const getSingleContent = (companyId: number, contentId: string) => {
  return axios.get(`${GET_SINGLE_CONTENT}/${companyId}/${contentId}`, {
    validateStatus() {
      return true
    },
  })
}

export const getSingleContentTimeSpend = (companyId: number, contentId: string) => {
  return axios.get(`${GET_SINGLE_CONTENT_TIME_SPEND}/${companyId}/${contentId}`, {
    validateStatus() {
      return true
    },
  })
}

export const addFileInDrUploadsUrl = (name: string, URL: string, dataRoomUpload: boolean) => {
  const payload = {
    name,
    URL,
    dataRoomUpload,
  }

  return axios.post(ADD_MORE_FILES, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateIsHiddenOrTrash = (
  dataroom_contentId: number,
  isHidden: boolean,
  isTrash: boolean
) => {
  return axios.put(
    `${UPDATE_IS_HIDDEN}/${dataroom_contentId}`,
    {isHidden, isTrash},
    {
      validateStatus() {
        return true
      },
    }
  )
}
export const getlocationData = (companyId: number, contentId: string, locationData: string) => {
  return axios.get(`${GET_LOCATION}/${companyId}/${contentId}?location=${locationData}`, {
    validateStatus() {
      return true
    },
  })
}

export const viewFileInDr = (contentId: string, publicSessionTokenDataroom: string) => {
  const headers = {
    'x-session-token': publicSessionTokenDataroom,
  }
  return axios.get(`${FILE_VIEW_IN_DATAROOM}/${contentId}`, {
    headers: headers,
  })
}

export const deleteDataRoomContent = (dataroom_contentId: number) => {
  return axios.delete(`${DELETE_CONTENT_DRROOT}/${dataroom_contentId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const downloadFileSignedForContent = (
  contentId: number | string,
  sessionToken: string | null
) => {
  const headers: any = {
    'x-session-token': sessionToken,
  }
  return axios.get(`${GET_SIGNEDURL_CONTENT}/${contentId}`, {
    headers: headers,
    validateStatus(status) {
      return true
    },
  })
}

export const getAccounts = (companyId: number) => {
  return axios.get(`${GET_ACCOUNT}/${companyId}`, {
    validateStatus() {
      return true
    },
  })
}
